<h2 mat-dialog-title>Odrzuć zaświadczenie</h2>

<mat-dialog-content>
  <mat-form-field appearance="fill" style="width: 100%;">
    <mat-label>Powód odrzucenia</mat-label>
    <input matInput [(ngModel)]="reason" />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Powrót</button>
  <button mat-flat-button color="primary" (click)="onConfirm()" [disabled]="!reason">
    Zatwierdź
  </button>
</mat-dialog-actions>
